import Vue from 'vue'

///Font Awesome Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faSignInAlt,
    faSignOutAlt,
    faEnvelope
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faEnvelope)
library.add(faSignInAlt)
library.add(faSignOutAlt)

Vue.component('font-awesome-icon', FontAwesomeIcon);

///Bootstrap 4
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootswatch/dist/yeti/bootstrap.min.css'


///SCA Vue Components

import '../assets/css/style.css'

import ScaHeader from "./Header.vue";
import ScaFooter from "./Footer.vue";

const Components = {
    ScaHeader,
    ScaFooter
};

Object.keys(Components).forEach(name => {
    Vue.component(name, Components[name]);
});

export default Components;
